import React, { useState, useRef, useEffect } from "react";
import Header from "../Components/Header";
import SideBar from "../Components/SideBar";
import {
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Step,
    StepLabel,
    Stepper,
    TextField,
    Typography,
} from "@mui/material";
import PhotoCameraFrontOutlinedIcon from "@mui/icons-material/PhotoCameraFrontOutlined";
import PhotoSizeSelectActualOutlinedIcon from "@mui/icons-material/PhotoSizeSelectActualOutlined";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useFormik } from "formik";
import * as Yup from 'yup';
import BASEURL from "../Connection/BASEURL";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import "../Pages/Print.css";
import { Add_Productlist, Clear_Productlist, selectProductlist } from "../Redux/Slice/ProductList";
import { useDispatch, useSelector } from "react-redux";
import { Add_User } from "../Redux/Slice/UserSlice";
import { Add_Client, Clear_Client, selectClient } from "../Redux/Slice/ClientsDetails";
import { Add_Bed, selectBed } from "../Redux/Slice/BedAllocation";
import { Add_Deceased, selectDeceased } from "../Redux/Slice/DeceasedDetails";
import { useNavigate, useLocation } from "react-router-dom";
import { Add_DeceasedID, selectDeceasedID } from "../Redux/Slice/Deceasedid";
import { Add_ClientID, selectClientID } from "../Redux/Slice/Clientid";
import { Add_Payment, selectPayment } from "../Redux/Slice/Payment";

const EditInvoice = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    // Get data from Redux store
    const productData = useSelector(selectProductlist);
    const ClientData = useSelector(selectClient);
    const BedData = useSelector(selectBed);
    const DeceasedData = useSelector(selectDeceased);
    const DeceasedID = useSelector(selectDeceasedID);
    const ClientID = useSelector(selectClientID);
    const paymentamount = useSelector(selectPayment);

    // Get invoice ID from navigation state
    const invoiceId = location.state?.id;
    
    // State variables
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [invoiceData, setInvoiceData] = useState(null);
    const [refreshData, setrefreshData] = useState(false);
    const [allDiscounts, setAllDiscounts] = useState([]);
    
    // Form states
    const [bed, setbed] = useState("");
    const [field, setfield] = useState("");
    const [letter, setletter] = useState("");
    const [number, setnumber] = useState("");
    const [fieldOptions, setFieldOptions] = useState([]);
    const [letterOptions, setLetterOptions] = useState([]);
    const [numberOptions, setNumberOptions] = useState([]);
    const [amountvalue, setamountvalue] = useState("");
    const [discountvalue, setdiscountvalue] = useState("");
    const [amountloading, setamountloading] = useState("");
    
    // Bed selection states
    const [selectbed, setselectbed] = useState("");
    const [selectfield, setselectfield] = useState("");
    const [selectletter, setselectletter] = useState("");
    const [selectnumber, setselectnumber] = useState("");
    const [repreLoading, setrepreLoading] = useState(false);
    const [all_allocatedbeds, setall_allocatedbeds] = useState([]);
    const [postloading, setpostloading] = useState(false);
    const [AvailableNumberArray, setAvaiilableNumberArray] = useState([]);
    const [AvailableNumberLoading, setAvailableNumberLoading] = useState(false);
    const [refreshNumber, setrefreshNumber] = useState(false);
    
    // Fee and tax states
    const [Get_Open_closing, setGet_Open_closing] = useState("");
    const [Get_All_Fees, setGet_All_Fees] = useState("");
    const [Get_Lowering_Device, setGet_Lowering_Device] = useState({});
    const [gettax, settax] = useState("");
    const [getnhil, setgetnhil] = useState("");
    
    // Stepper state
    const [activeStep, setActiveStep] = useState(0);
    const [loading2, setloading2] = useState(false);
    const [productListLoading, setproductListLaoding] = useState(false);
    
    // Form options
    const GenderArray = ["Male", "Female"];
    const Religion = ["Muslim", "Christian", "Other"];
    const RelationshipArray = ["Mother", "Father", "Friend", "Aunty", "Uncle", "Niece", "Nephew", "Sister", "Brother", "Grand Mother", "Grand Father", "Other"];
    const sale_of_grave_list = ["Adult_Single", "Adult_Double", "Child_Single", "Infant"];
    const Opening_Closing = ["OC_Single", "OC_Double"];
    const [sale_of_grave, setsale_of_grave] = useState("");
    const [opening_Closing, setopening_Closing] = useState("");

    const steps = ["Deceased Data", "Select Particular Bed", "Product Selection", "Payment Amount"];

    // Fetch invoice data on component mount
    useEffect(() => {
        if (invoiceId) {
            fetchInvoiceData();
        } else {
            setError('No invoice ID provided');
        }
    }, [invoiceId]);

    // Fetch all necessary data
    useEffect(() => {
        fetchDiscounts();
        fetchAllBeds();
        fetchTaxData();
        fetchMaintenanceFees();
    }, []);

    // Bed selection effects
    useEffect(() => {
        if (bed) {
            axios.get(`${BASEURL}/fields/null/${bed}`).then((response) => {
                const data = response.data;
                setFieldOptions(data);
            }).catch((error) => {
                console.log('Error fetching fields:', error);
            });
        } else {
            setFieldOptions([]);
        }
    }, [bed]);

    useEffect(() => {
        if (field) {
            axios.get(`${BASEURL}/letters/null/${bed}/${field}`).then((response) => {
                const data = response.data;
                setLetterOptions(data);
            }).catch((error) => {
                console.log('Error fetching letters:', error);
            });
        } else {
            setLetterOptions([]);
        }
    }, [field]);

    useEffect(() => {
        if (letter) {
            axios.get(`${BASEURL}/numbers/null/${bed}/${field}/${letter}`).then((response) => {
                const data = response.data;
                setNumberOptions(data);
            }).catch((error) => {
                console.log('Error fetching numbers:', error);
            });
        } else {
            setNumberOptions([]);
        }
    }, [letter]);

    // Fetch fee data when sale_of_grave changes
    useEffect(() => {
        if (sale_of_grave) {
            axios.get(`${BASEURL}/fee/1/${sale_of_grave}`).then((response) => {
                const data = response.data;
                setGet_All_Fees(data);
            }).catch((error) => {
                console.log('Error fetching fee data:', error);
            });
        }
    }, [sale_of_grave]);

    const fetchInvoiceData = async () => {
        try {
            setLoading(true);
            setError(null);
            // Fetch deceased data
            const deceasedResponse = await axios.get(`${BASEURL}/deceased/${invoiceId}`);
            const deceasedData = deceasedResponse.data;
            
            // Fetch client data if client ID exists
            let clientData = null;
            if (deceasedData.repreid) {
                try {
                    const clientResponse = await axios.get(`${BASEURL}/clients/${deceasedData.repreid}`);
                    clientData = clientResponse.data;
                } catch (error) {
                    console.log('Client data not found');
                }
            }
            
            setInvoiceData({ deceased: deceasedData, client: clientData });
            
            // Pre-populate Redux store
            if (clientData) {
                dispatch(Add_Client(clientData));
                dispatch(Add_ClientID({ id: clientData.tblid }));
            }
            
            dispatch(Add_Deceased(deceasedData));
            dispatch(Add_DeceasedID({ id: deceasedData.tblid }));
            
            if (deceasedData.bed) {
                dispatch(Add_Bed({ bedname: deceasedData.bed }));
            }
            
            if (deceasedData.sale_of_grave) {
                dispatch(Add_Productlist({
                    sale_of_grave: deceasedData.sale_of_grave,
                    open_and_closing: deceasedData.open_and_closing
                }));
            }
            
            if (deceasedData.payment_amount) {
                dispatch(Add_Payment({ payment: deceasedData.payment_amount }));
                setamountvalue(deceasedData.payment_amount.toString());
            }
            
            // Pre-populate form fields
            if (deceasedData.bed) {
                // Parse bed information if available
                const bedParts = deceasedData.bed.split('-');
                if (bedParts.length >= 4) {
                    setselectbed(bedParts[0]);
                    setselectfield(bedParts[1]);
                    setselectletter(bedParts[2]);
                    setselectnumber(bedParts[3]);
                }
            }
            
            if (deceasedData.sale_of_grave) {
                setsale_of_grave(deceasedData.sale_of_grave);
            }
            
            if (deceasedData.open_and_closing) {
                setopening_Closing(deceasedData.open_and_closing);
            }
            
            if (deceasedData.discount) {
                setdiscountvalue(deceasedData.discount.toString());
            }
            
            toast.success('Invoice data loaded successfully!', { position: toast.POSITION.TOP_CENTER });
        } catch (error) {
            console.log('Error fetching invoice data:', error);
            setError('Failed to load invoice data');
            toast.error('Failed to load invoice data', { position: toast.POSITION.TOP_CENTER });
        } finally {
            setLoading(false);
        }
    };

    const fetchDiscounts = async () => {
        try {
            const response = await axios.get(`${BASEURL}/discounts`);
            const data = response.data;
            const discountsWithCreatedAt = data.map(discount => ({
                ...discount,
                createdAt: discount.createdAt || new Date().toISOString()
            }));
            setAllDiscounts(discountsWithCreatedAt);
            
            if (discountsWithCreatedAt.length > 0) {
                setdiscountvalue(discountsWithCreatedAt[0].discount_amount || "");
            }
        } catch (error) {
            console.log('Error fetching discounts:', error);
        }
    };

    const fetchAllBeds = async () => {
        try {
            const response = await axios.get(`${BASEURL}/beds/`);
            setall_allocatedbeds(response.data);
        } catch (error) {
            console.log('Error fetching beds:', error);
        }
    };

    const fetchTaxData = async () => {
        try {
            const [taxResponse, nhilResponse] = await Promise.all([
                axios.get(`${BASEURL}/tax/1/vat`),
                axios.get(`${BASEURL}/tax/1/nhil_levy`)
            ]);
            settax(taxResponse.data);
            setgetnhil(nhilResponse.data);
        } catch (error) {
            console.log('Error fetching tax data:', error);
        }
    };

    const fetchMaintenanceFees = async () => {
        try {
            const response = await axios.get(`${BASEURL}/maintenance-fees`);
            const data = response.data;
            const maintenanceFeesWithCreatedAt = data.map(fee => ({
                ...fee,
                createdAt: fee.createdAt || new Date().toISOString()
            }));
            // Set maintenance fees if needed
        } catch (error) {
            console.log('Error fetching maintenance fees:', error);
        }
    };

    // Stepper navigation
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepClick = (step) => {
        setActiveStep(step);
    };


    const handleSubmitDeceased = async (values) => {
        try {
            setloading2(true);
            const response = await axios.put(`${BASEURL}/deceased/${DeceasedID?.id}`, values);
            const data = response.data;
            dispatch(Add_Deceased({
                fname: values.fname,
                lname: values.lname,
                dod: values.dod,
                aged: values.Aged,
                dobrial: values.dobrial
            }));
            
            if (data) {
                toast.success("Deceased Updated Successfully", {
                    position: toast.POSITION.TOP_CENTER
                });
                handleNext();
            }
        } catch (error) {
            console.log('Error updating deceased:', error);
            toast.error('Failed to update deceased', { position: toast.POSITION.TOP_CENTER });
        } finally {
            setloading2(false);
        }
    };

    const handleSubmitBed = async () => {
        try {
            setpostloading(true);
            const payload = {
                bed: `${selectbed}-${selectfield}-${selectletter}-${selectnumber}`
            };
            
            const response = await axios.put(`${BASEURL}/deceased/${DeceasedID?.id}`, payload);
            
            if (response.data) {
                dispatch(Add_Bed({
                    bedname: `${selectbed}-${selectfield}-${selectletter}-${selectnumber}`
                }));
                
                toast.success("Bed Updated Successfully", {
                    position: toast.POSITION.TOP_CENTER
                });
                handleNext();
            }
        } catch (error) {
            console.log('Error updating bed:', error);
            toast.error('Failed to update bed', { position: toast.POSITION.TOP_CENTER });
        } finally {
            setpostloading(false);
        }
    };

    const handleSubmitProduct = async () => {
        try {
            setproductListLaoding(true);
            const payload = {
                sale_of_grave: sale_of_grave,
                open_and_closing: opening_Closing
            };
            
            const response = await axios.put(`${BASEURL}/deceased/${DeceasedID?.id}`, payload);
            
            if (response.data) {
                dispatch(Add_Productlist({
                    sale_of_grave: sale_of_grave,
                    open_and_closing: opening_Closing
                }));
                
                toast.success("Product Updated Successfully", {
                    position: toast.POSITION.TOP_CENTER
                });
                handleNext();
            }
        } catch (error) {
            console.log('Error updating product:', error);
            toast.error('Failed to update product', { position: toast.POSITION.TOP_CENTER });
        } finally {
            setproductListLaoding(false);
        }
    };

    const handleSubmitPayment = async () => {
        try {
            setamountloading(true);
            const payload = {
                payment_amount: amountvalue,
                discount: discountvalue,
                date_of_payment: dayjs().format('YYYY-MM-DD'),
                customer_name: ClientData?.fname + " " + ClientData?.lname,
                customer_phone: ClientData?.phone,
                total_amount_with_discount: parseFloat(amountvalue) - (parseFloat(amountvalue) * parseFloat(discountvalue || 0) / 100)
            };
            
            const response = await axios.put(`${BASEURL}/deceased/${DeceasedID?.id}`, payload);
            
            if (response.data) {
                dispatch(Add_Payment({ payment: amountvalue }));
                toast.success("Payment Updated Successfully", {
                    position: toast.POSITION.TOP_CENTER
                });
                handleNext();
            }
        } catch (error) {
            console.log('Error updating payment:', error);
            toast.error('Failed to update payment', { position: toast.POSITION.TOP_CENTER });
        } finally {
            setamountloading(false);
        }
    };


    const deceasedFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            fname: DeceasedData?.fname || '',
            mname: DeceasedData?.mname || "",
            lname: DeceasedData?.lname || "",
            gender: DeceasedData?.gender || "",
            dob: DeceasedData?.dob ? dayjs(DeceasedData.dob) : null,
            dod: DeceasedData?.dod ? dayjs(DeceasedData.dod) : null,
            placeofdeath: DeceasedData?.placeofdeath || "",
            occupation: DeceasedData?.occupation || "",
            religion: DeceasedData?.religion || "",
            nameofwitness: DeceasedData?.nameofwitness || "",
            daddressofwitness: DeceasedData?.daddressofwitness || "",
            phoneofwitness: DeceasedData?.phoneofwitness || "",
            dobrial: DeceasedData?.dobrial ? dayjs(DeceasedData.dobrial) : null,
            Aged: DeceasedData?.Aged || ""
        },
        onSubmit: handleSubmitDeceased,
    });

    // Utility functions
    function getCurrentDate() {
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        const currentDate = new Date().toLocaleDateString(undefined, options);
        return currentDate;
    }

    function generateRandom5DigitNumber() {
        const min = 10000;
        const max = 99999;
        const random5DigitNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        return random5DigitNumber;
    }

    const formattedDate = getCurrentDate();
    const random5DigitNumber = generateRandom5DigitNumber();

    // Calculations
    const percentage_NHIL_SALE_OF_GARVE = getnhil;
    const amount_NHIL_SALE_OF_GARVE = Get_All_Fees;
    const result_amount_NHIL_SALE_OF_GARVE = ((percentage_NHIL_SALE_OF_GARVE / 100) * amount_NHIL_SALE_OF_GARVE);
    const Total_Combination_of_Tax1 = parseFloat(Get_All_Fees) + parseFloat(result_amount_NHIL_SALE_OF_GARVE);
    const percentageSALE_OF_GARVE = gettax;
    const amountSALE_OF_GARVE = Get_All_Fees;
    const resultSALE_OF_GARVE = ((percentageSALE_OF_GARVE / 100) * Total_Combination_of_Tax1);
    const TOTAL_NHILGETFUND = parseFloat(result_amount_NHIL_SALE_OF_GARVE);
    const TOTAL_TAX = parseFloat(resultSALE_OF_GARVE);
    const Ext_PriceTotal = parseFloat(Get_All_Fees);
    const GRAND_TOTAL = parseFloat(Total_Combination_of_Tax1) + parseFloat(resultSALE_OF_GARVE);
    const AmountLeft = parseFloat(GRAND_TOTAL) - parseFloat(paymentamount?.payment);

    if (loading) {
        return (
            <>
                <ToastContainer />
                <div className="grid grid-cols-12">
                    <div className="col-span-2 hidden lg:block">
                        <SideBar />
                    </div>
                    <div className="col-span-12 lg:col-span-10 bg-[#D2D2CF]">
                        <Header />
                        <div className="flex items-center justify-center min-h-screen">
                            <div className="text-center">
                                <CircularProgress size={60} style={{ color: "#0F1D48" }} />
                                <Typography variant="h6" className="mt-4 text-[#0F1D48]">
                                    Loading invoice data...
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <ToastContainer />
                <div className="grid grid-cols-12">
                    <div className="col-span-2 hidden lg:block">
                        <SideBar />
                    </div>
                    <div className="col-span-12 lg:col-span-10 bg-[#D2D2CF]">
                        <Header />
                        <div className="flex items-center justify-center min-h-screen">
                            <div className="text-center">
                                <Typography variant="h6" className="text-red-600">
                                    {error}
                                </Typography>
                                <Button 
                                    onClick={() => navigate('/all-deceased')}
                                    variant="contained"
                                    style={{ backgroundColor: "#0F1D48", color: "white", marginTop: 16 }}
                                >
                                    Back to All Deceased
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <ToastContainer />
            <div className="grid grid-cols-12">
                <div className="col-span-2 hidden lg:block">
                    <SideBar />
                </div>
                <div className="col-span-12 lg:col-span-10 bg-[#D2D2CF]">
                    <Header />
                    <div className="px-6 py-6">
                        <div className="flex items-center justify-between">
                            <h1 className="text-2xl lg:text-4xl font-bold text-[#111927] py-2">
                                Edit Invoice
                            </h1>
                            <Button 
                                onClick={() => navigate('/all-deceased')}
                                variant="contained"
                                style={{ backgroundColor: "#6B7280", color: "white" }}
                            >
                                Back to All Deceased
                            </Button>
                        </div>

                        <Paper
                            elevation={3}
                            className="bg-white mt-4 lg:mt-8 p-2 lg:p-5"
                            style={{ borderRadius: 20 }}
                        >
                            <div className="py-8">
                                <Stepper
                                    activeStep={activeStep}
                                    nonLinear
                                >
                                    {steps.map((label, index) => (
                                        <Step key={label}>
                                            <StepLabel
                                                onClick={() => handleStepClick(index)}
                                                style={{
                                                    color: "#A4A8AD",
                                                    fontSize: 20,
                                                    fontFamily: "'Poppins', sans-serif",
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                {label}
                                            </StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </div>

                            {/* Step 0: Deceased Data */}
                            {activeStep === 0 && (
                                <div>
                                    <form onSubmit={deceasedFormik.handleSubmit}>
                                        <div className="grid grid-cols-2 gap-6 px-3">
                                            <TextField
                                                fullWidth
                                                placeholder="First Name"
                                                label="First Name"
                                                id="fname"
                                                name="fname"
                                                variant="outlined"
                                                {...deceasedFormik.getFieldProps('fname')}
                                            />
                                            <TextField
                                                fullWidth
                                                placeholder="Maiden Name"
                                                label="Middle Name"
                                                id="mname"
                                                name="mname"
                                                variant="outlined"
                                                {...deceasedFormik.getFieldProps('mname')}
                                            />
                                            <TextField
                                                fullWidth
                                                placeholder="Last Name"
                                                label="Last Name"
                                                id="lname"
                                                name="lname"
                                                variant="outlined"
                                                {...deceasedFormik.getFieldProps('lname')}
                                            />
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Select Gender</InputLabel>
                                                <Select
                                                    name="gender"
                                                    value={deceasedFormik.values.gender}
                                                    onChange={deceasedFormik.handleChange}
                                                    onBlur={deceasedFormik.handleBlur}
                                                >
                                                    {GenderArray.map((list) => (
                                                        <MenuItem key={list} value={list}>{list}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format="YYYY-MM-DD"
                                                    label="Date of Birth"
                                                    name="dob"
                                                    onBlur={deceasedFormik.handleBlur}
                                                    value={deceasedFormik.values.dob}
                                                    onChange={(date) => {
                                                        const formattedDate = dayjs(date).format('YYYY-MM-DD');
                                                        deceasedFormik.setFieldValue('dob', formattedDate);
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format="YYYY-MM-DD"
                                                    label="Date of Death"
                                                    name="dod"
                                                    onBlur={deceasedFormik.handleBlur}
                                                    value={deceasedFormik.values.dod}
                                                    onChange={(date) => {
                                                        const formattedDate = dayjs(date).format('YYYY-MM-DD');
                                                        deceasedFormik.setFieldValue('dod', formattedDate);
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                            <TextField
                                                fullWidth
                                                label="Place of Death"
                                                placeholder="Place of Death"
                                                id="placeofdeath"
                                                name="placeofdeath"
                                                variant="outlined"
                                                {...deceasedFormik.getFieldProps('placeofdeath')}
                                            />
                                            <TextField
                                                fullWidth
                                                label="Occupation"
                                                placeholder="Occupation"
                                                id="occupation"
                                                name="occupation"
                                                variant="outlined"
                                                {...deceasedFormik.getFieldProps('occupation')}
                                            />
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Select Religion</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    name="religion"
                                                    value={deceasedFormik.values.religion}
                                                    onChange={deceasedFormik.handleChange}
                                                    onBlur={deceasedFormik.handleBlur}
                                                >
                                                    {Religion.map((list) => (
                                                        <MenuItem key={list} value={list}>{list}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <TextField
                                                fullWidth
                                                label="Name of Witness"
                                                placeholder="Name of Witness"
                                                id="nameofwitness"
                                                name="nameofwitness"
                                                variant="outlined"
                                                {...deceasedFormik.getFieldProps('nameofwitness')}
                                            />
                                            <TextField
                                                fullWidth
                                                label="Address of Witness"
                                                placeholder="Address of Witness"
                                                id="daddressofwitness"
                                                name="daddressofwitness"
                                                variant="outlined"
                                                {...deceasedFormik.getFieldProps('daddressofwitness')}
                                            />
                                            <TextField
                                                fullWidth
                                                label="Phone number of witness"
                                                placeholder="Phone number of witness"
                                                id="phoneofwitness"
                                                name="phoneofwitness"
                                                variant="outlined"
                                                {...deceasedFormik.getFieldProps('phoneofwitness')}
                                            />
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Date of burial"
                                                    format="YYYY-MM-DD"
                                                    name="dobrial"
                                                    value={deceasedFormik.values.dobrial}
                                                    onChange={(date) => {
                                                        const formattedDate = dayjs(date).format('YYYY-MM-DD');
                                                        deceasedFormik.setFieldValue('dobrial', formattedDate);
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                            <TextField
                                                type="number"
                                                fullWidth
                                                label="Age of deceased"
                                                placeholder="Age of deceased"
                                                id="Aged"
                                                name="Aged"
                                                variant="outlined"
                                                {...deceasedFormik.getFieldProps('Aged')}
                                            />
                                        </div>
                                        <div className="flex justify-end items-center mt-7">
                                            {loading2 ? (
                                                <Button
                                                    variant="contained"
                                                    style={{
                                                        fontFamily: "'Poppins', sans-serif",
                                                        borderRadius: 8,
                                                        paddingLeft: 20,
                                                        paddingRight: 20,
                                                        paddingTop: 10,
                                                        paddingBottom: 10,
                                                        backgroundColor: "#083050",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    <CircularProgress size={17} style={{ color: "white" }} />
                                                </Button>
                                            ) : (
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    style={{
                                                        fontFamily: "'Poppins', sans-serif",
                                                        borderRadius: 8,
                                                        paddingLeft: 20,
                                                        paddingRight: 20,
                                                        paddingTop: 10,
                                                        paddingBottom: 10,
                                                        backgroundColor: "#083050",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    Update and Continue
                                                </Button>
                                            )}
                                        </div>
                                    </form>
                                </div>
                            )}

                            {/* Step 1: Select Particular Bed */}
                            {activeStep === 1 && (
                                <div className="px-60 py-16 space-y-6">
                                    <FormControl fullWidth>
                                        <InputLabel>Select Bed Type</InputLabel>
                                        <Select
                                            onChange={(e) => {
                                                setbed(e.target.value);
                                                const selectedbed = all_allocatedbeds.find((option) => option.id === e.target.value);
                                                setselectbed(selectedbed ? selectedbed.name : "");
                                            }}
                                            label="Select Bed Type"
                                            value={bed}
                                        >
                                            {all_allocatedbeds.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth>
                                        <InputLabel>Select Section</InputLabel>
                                        <Select
                                            value={field}
                                            onChange={(e) => {
                                                setfield(e.target.value);
                                                const selectedfield = fieldOptions.find((option) => option.id === e.target.value);
                                                setselectfield(selectedfield ? selectedfield.name : "");
                                            }}
                                            label="Select Section"
                                        >
                                            {fieldOptions.map((option) => (
                                                <MenuItem key={option} value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth>
                                        <InputLabel>Select Sub Section</InputLabel>
                                        <Select
                                            value={letter}
                                            onChange={(e) => {
                                                setletter(e.target.value);
                                                const selectedletter = letterOptions.find((option) => option.id === e.target.value);
                                                setselectletter(selectedletter ? selectedletter.name : "");
                                            }}
                                            label="Select Sub-Section"
                                        >
                                            {letterOptions.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth>
                                        <InputLabel>Select Division</InputLabel>
                                        <Select
                                            value={number}
                                            onChange={(e) => {
                                                setnumber(e.target.value);
                                                const selectednumber = numberOptions.find((option) => option.id === e.target.value);
                                                setselectnumber(selectednumber ? selectednumber.number : "");
                                            }}
                                        >
                                            {numberOptions.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.number}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <div className="grid place-items-center mt-10">
                                        {postloading ? (
                                            <Button style={{ width: "30%", backgroundColor: "#083050", color: "white", padding: 12 }}>
                                                <CircularProgress size={17} style={{ color: "white" }} />
                                            </Button>
                                        ) : (
                                            <Button
                                                onClick={handleSubmitBed}
                                                style={{ width: "30%", backgroundColor: "#083050", color: "white", padding: 12 }}
                                            >
                                                Update and Continue
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Step 2: Product Selection */}
                            {activeStep === 2 && (
                                <div className="pb-32 px-32">
                                    <div>
                                        <div>
                                            <h1 className="py-2 text-center">Sale of Grave</h1>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Select Type</InputLabel>
                                                <Select
                                                    value={sale_of_grave}
                                                    onChange={(e) => {
                                                        setsale_of_grave(e.target.value);
                                                    }}
                                                    label="relationship"
                                                    name="relationship"
                                                >
                                                    {sale_of_grave_list.map((list) => (
                                                        <MenuItem key={list} value={list}>{list}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="grid place-items-center mt-10">
                                            {productListLoading ? (
                                                <Button>
                                                    <CircularProgress style={{ color: "white", backgroundColor: "#083050", color: "white", padding: 12 }} />
                                                </Button>
                                            ) : (
                                                <Button 
                                                    onClick={handleSubmitProduct} 
                                                    style={{ width: "30%", backgroundColor: "#083050", color: "white", padding: 12 }}
                                                >
                                                    Update and Continue
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Step 3: Payment Amount */}
                            {activeStep === 3 && (
                                <div className="mx-28 py-12">
                                    <div className="grid place-items-center">
                                        <div style={{ border: "2px solid #000000", padding: 8 }} className="space-y-2 pb-3">
                                            <h1 className="font-semibold">{`VALUE ADDED TAX : ₵ ${resultSALE_OF_GARVE.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                            <h1 className="font-semibold">{`NHIL & GET FUND LEVY : ₵ ${Total_Combination_of_Tax1.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                            <h1 className="font-semibold">{`TOTAL :₵ ${GRAND_TOTAL.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                        </div>
                                    </div>
                                    <h1 className="text-center py-7">Payment Amount</h1>
                                    <TextField 
                                        value={amountvalue} 
                                        onChange={(e) => {
                                            setamountvalue(e.target.value);
                                        }} 
                                        type="number" 
                                        fullWidth 
                                        label="Enter Amount" 
                                        placeholder="Enter Amount" 
                                    />
                                    <TextField 
                                        value={discountvalue} 
                                        onChange={(e) => {
                                            setdiscountvalue(e.target.value);
                                        }} 
                                        type="number" 
                                        fullWidth 
                                        label="Discount %" 
                                        placeholder="Enter Discount %" 
                                        style={{ marginTop: 16 }} 
                                    />
                                    <div className="grid place-items-center mt-10">
                                        {amountloading ? (
                                            <Button style={{ width: "30%", backgroundColor: "#083050", color: "white", padding: 12 }}>
                                                <CircularProgress size={16} style={{ color: "white" }} />
                                            </Button>
                                        ) : (
                                            <Button 
                                                onClick={handleSubmitPayment} 
                                                style={{ width: "30%", backgroundColor: "#083050", color: "white", padding: 12 }}
                                            >
                                                Update and Continue
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            )}

                            
                            {/* Navigation buttons */}
                            <div className="flex justify-between items-center mt-8">
                                <Button
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                    variant="outlined"
                                    style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        borderRadius: 8,
                                        paddingLeft: 20,
                                        paddingRight: 20,
                                        paddingTop: 10,
                                        paddingBottom: 10,
                                        borderColor: "#083050",
                                        color: "#083050",
                                    }}
                                >
                                    Back
                                </Button>
                                
                                {activeStep < steps.length - 1 ? (
                                    <Button
                                        onClick={handleNext}
                                        variant="contained"
                                        style={{
                                            fontFamily: "'Poppins', sans-serif",
                                            borderRadius: 8,
                                            paddingLeft: 20,
                                            paddingRight: 20,
                                            paddingTop: 10,
                                            paddingBottom: 10,
                                            backgroundColor: "#083050",
                                            color: "white",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Next
                                    </Button>
                                ) : (
                                    <Button
                                        onClick={() => {
                                            navigate("/all-deceased");
                                        }}
                                        variant="contained"
                                        style={{
                                            fontFamily: "'Poppins', sans-serif",
                                            borderRadius: 8,
                                            paddingLeft: 20,
                                            paddingRight: 20,
                                            paddingTop: 10,
                                            paddingBottom: 10,
                                            backgroundColor: "#22C55E",
                                            color: "white",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Done
                                    </Button>
                                )}
                            </div>
                        </Paper>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditInvoice;
